/** @format */

import React, { useRef, useState } from "react";
import MarketOverviewCommodities from "./MarketOverviewCommodities";
import { COCOA_MARKET_OVERVIEW_ORDER } from "./constants/constants";
import { isMarketOverviewEmpty } from "./utils/utils";
import { BUSINESS_UNIT } from "../../utils/PreviousSession.constants";
import { Button } from "primereact/button";
import ThreeDotsLoader from "../common/ThreeDotsLoader";
import { Messages } from "primereact/messages";
import { Dialog } from "primereact/dialog";
import useSaveMarketOverview from "./hooks/useSaveMarketOverview";

function MarketOverview(props) {
  let section = props.section;
  let loading = props.loading;
  const msgRef = useRef();
  const mutation = useSaveMarketOverview();
  const [isSectionInValid, setIsSectionInValid] = useState(false);
  function saveCommodityComments(arg) {
    props.getSectionData(section);
  }

  // const [NAList, setNAList] = useState([]);
  // const [SAList, setSAList] = useState([]);
  // const [EMEAList, setEMEAList] = useState([]);

  const headerImgSrc =
    props.businessUnit !== BUSINESS_UNIT.COCOA
      ? "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/MarketOverviewHeader.png"
      : "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/cocoa_martket_overview.png";

  React.useEffect(() => {
    // var date=moment(props.selectedDate).format("YYYY-MM-DD");
    // service.getSyndication(date, 'NA', props.channel.value, props.channel.label).then((res) => {
    //   if(res.data.marketOverview!==undefined && res.data.marketOverview!==null){
    //     setNAList(res.data.marketOverview.marketOverviewSections);
    //   }
    // });
    // service.getSyndication(date, 'SA', props.channel.value, props.channel.label).then((res) => {
    //   if(res.data.marketOverview!==undefined && res.data.marketOverview!==null){
    //     setSAList(res.data.marketOverview.marketOverviewSections);
    //   }
    // });
    // service.getSyndication(date, 'EMEA', props.channel.value, props.channel.label).then((res) => {
    //   if(res.data.marketOverview!==undefined && res.data.marketOverview!==null){
    //     setEMEAList(res.data.marketOverview.marketOverviewSections);
    //   }
    // });
    // service.getImageCode("MarketOverviewHeader.jpeg", setHeaderImgSrc)
  }, [props.selectedDate, props.channel]);

  const isCocoa = props.channel.label && props.channel.label.toLowerCase() === BUSINESS_UNIT.COCOA.toLowerCase();

  if (section.marketOverviewSections && isCocoa) {
    section.marketOverviewSections.sort(
      (a, b) => COCOA_MARKET_OVERVIEW_ORDER.indexOf(a.title) - COCOA_MARKET_OVERVIEW_ORDER.indexOf(b.title)
    );
  }

  function handleSectionSave() {
    if (isMarketOverviewEmpty(section)) {
      setIsSectionInValid(true);
    } else {
      mutation.mutate(
        {
          ...section,
          reportDate: props.reportDate,
          regionId: props.regionId,
          productLineId: props.productLineId,
        },
        {
          onSuccess: (data) => {
            if (msgRef.current) {
              msgRef.current.clear();
              msgRef.current.show([
                {
                  sticky: false,
                  severity: "success",
                  summary: "Success",
                  detail: "Market Overview saved successfully",
                  closable: false,
                  life: 2000,
                },
              ]);
            }
            props.setEditing("marketOverview", false, false);
            props.updateSectionId("marketOverview", data.data);
            mutation.reset();
          },
          onError: () => {
            if (msgRef.current) {
              msgRef.current.clear();
              msgRef.current.show([
                {
                  sticky: true,
                  severity: "error",
                  summary: "Error",
                  detail: "Error saving Early Markets",
                  closable: true,
                },
              ]);
            }
            props.setEditing("marketOverview", true, false);
            mutation.reset();
          },
        }
      );
    }
  }
  return (
    <div className='relative syndication__section__wrapper'>
      <table
        align='center'
        style={{
          width: "800px",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
        }}
      >
        <tbody>
          <tr>
            <td>
              <img
                src={section?.headerImagePath || headerImgSrc}
                alt=' market overview header'
                width='800'
                height='50'
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>
      {(loading || mutation.isLoading) && (
        <div className='wtg__loader absolute'>
          <ThreeDotsLoader className='absolute' />
        </div>
      )}
      <table width='800' align='center' className='msg__container'>
        <Messages
          className='msg__content'
          ref={msgRef}
          onRemove={() => {
            console.log("REMOVED");
          }}
        />
      </table>
      <table
        align='center'
        style={{
          width: "800px",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
        }}
      >
        <tbody>
          {section.marketOverviewSections && (
            <>
              {section.marketOverviewSections.map((obj, index) => {
                return (
                  <MarketOverviewCommodities
                    setEditing={props.setEditing}
                    businessUnit={props.businessUnit}
                    obj={obj}
                    key={index}
                    publish={props.publish}
                    diff_date={props.diff_date}
                    regions={props.regions}
                    region={props.region}
                    saveCommodityComments={saveCommodityComments}
                    getContentBasedonDateAndRegion={props.getContentBasedonDateAndRegion}
                  />
                );
              })}
              {props.publish === false && props.diff_date >= 0 ? (
                <Button
                  pt={{ label: { className: "mx-0" } }}
                  className='p-button p-button-sm diag-save-button savesectionbtn'
                  label='Save Section Content'
                  onClick={() => handleSectionSave()}
                />
              ) : null}
            </>
          )}
        </tbody>
      </table>
      <Dialog
        header='Market Overview Validation'
        className='section__validation__dialog'
        baseZIndex={10001}
        visible={isSectionInValid}
        modal
        style={{ width: "350px" }}
        footer={
          <Button
            label='Okay'
            icon='pi pi-check'
            onClick={() => setIsSectionInValid(false)}
            className='p-button-text'
          />
        }
        onHide={() => setIsSectionInValid(false)}
      >
        <div className='flex flex-column' style={{ color: "#FFF" }}>
          <div className='flex align-items-center'>
            <i className='pi pi-exclamation-triangle mr-3' style={{ fontSize: "2rem" }} />
            <span>Please fill the section content</span>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default MarketOverview;
